
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { tuple_type, array_type, obj_type, bool_type, record_type, union_type, option_type, anonRecord_type, int32_type, list_type, lambda_type, unit_type, class_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Label_$reflection } from "../../Shared/Category.js";
import { SavedTableFilter_$reflection, TableConfiguration_$reflection } from "../../Shared/User.js";
import { ClientApiResponse$1_$reflection, RequestedValue$1_$reflection } from "../../Shared/Shared.js";

export class CellContent extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Text", "Component", "ButtonCell", "Labels", "Image", "Images", "Date", "DateTime"];
    }
}

export function CellContent_$reflection() {
    return union_type("Widgets.Table.Types.CellContent", [], CellContent, () => [[["Item", string_type]], [["Item", class_type("Fable.React.ReactElement")]], [["label", string_type], ["onClick", lambda_type(unit_type, unit_type)]], [["Item", list_type(Label_$reflection())]], [["imageUrl", string_type]], [["imageUrls", list_type(anonRecord_type(["ImageUrl", string_type], ["Position", int32_type]))]], [["Item", option_type(class_type("System.DateTime"))]], [["Item", class_type("System.DateTime")]]]);
}

export class OnTableRowClick$1 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Action", "URL"];
    }
}

export function OnTableRowClick$1_$reflection(gen0) {
    return union_type("Widgets.Table.Types.OnTableRowClick`1", [gen0], OnTableRowClick$1, () => [[["Item", lambda_type(gen0, unit_type)]], [["Item", lambda_type(gen0, string_type)]]]);
}

export class ColumnDefinition$1 extends Record {
    constructor(Id, Group, Header, AccessorFunction, Filter, ColumnType) {
        super();
        this.Id = Id;
        this.Group = Group;
        this.Header = Header;
        this.AccessorFunction = AccessorFunction;
        this.Filter = Filter;
        this.ColumnType = ColumnType;
    }
}

export function ColumnDefinition$1_$reflection(gen0) {
    return record_type("Widgets.Table.Types.ColumnDefinition`1", [gen0], ColumnDefinition$1, () => [["Id", string_type], ["Group", string_type], ["Header", string_type], ["AccessorFunction", lambda_type(gen0, CellContent_$reflection())], ["Filter", string_type], ["ColumnType", string_type]]);
}

export class State$1 extends Record {
    constructor(TableKey, SaveTableConfiguration, GlobalSearchPattern, SelectedRows, CSVDownloadRunning, IsFullscreen, ColumnFilters, ColumnSorting, VisibleColumns, ColumnOrder, TableConfiguration, ColumnDefinitions, ColumnDefinitionMap, DefaultColumnFilters, DefaultColumnSorting, SavedFilters, WithQueryParameters) {
        super();
        this.TableKey = TableKey;
        this.SaveTableConfiguration = SaveTableConfiguration;
        this.GlobalSearchPattern = GlobalSearchPattern;
        this.SelectedRows = SelectedRows;
        this.CSVDownloadRunning = CSVDownloadRunning;
        this.IsFullscreen = IsFullscreen;
        this.ColumnFilters = ColumnFilters;
        this.ColumnSorting = ColumnSorting;
        this.VisibleColumns = VisibleColumns;
        this.ColumnOrder = ColumnOrder;
        this.TableConfiguration = TableConfiguration;
        this.ColumnDefinitions = ColumnDefinitions;
        this.ColumnDefinitionMap = ColumnDefinitionMap;
        this.DefaultColumnFilters = DefaultColumnFilters;
        this.DefaultColumnSorting = DefaultColumnSorting;
        this.SavedFilters = SavedFilters;
        this.WithQueryParameters = WithQueryParameters;
    }
}

export function State$1_$reflection(gen0) {
    return record_type("Widgets.Table.Types.State`1", [gen0], State$1, () => [["TableKey", string_type], ["SaveTableConfiguration", bool_type], ["GlobalSearchPattern", string_type], ["SelectedRows", obj_type], ["CSVDownloadRunning", bool_type], ["IsFullscreen", bool_type], ["ColumnFilters", array_type(anonRecord_type(["id", string_type], ["value", obj_type]))], ["ColumnSorting", array_type(anonRecord_type(["desc", bool_type], ["id", string_type]))], ["VisibleColumns", array_type(string_type)], ["ColumnOrder", array_type(string_type)], ["TableConfiguration", RequestedValue$1_$reflection(TableConfiguration_$reflection())], ["ColumnDefinitions", array_type(ColumnDefinition$1_$reflection(gen0))], ["ColumnDefinitionMap", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, ColumnDefinition$1_$reflection(gen0)])], ["DefaultColumnFilters", option_type(list_type(anonRecord_type(["id", string_type], ["value", obj_type])))], ["DefaultColumnSorting", tuple_type(string_type, string_type)], ["SavedFilters", list_type(SavedTableFilter_$reflection())], ["WithQueryParameters", bool_type]]);
}

export class TableMsg$1 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetColumnDefinitions", "SetGlobalSearchPattern", "SetSelectedRows", "SetCSVDownloadRunning", "ToggleFullscreen", "SetColumnFilters", "ApplyColumnFilters", "SetColumnSorting", "SetColumnVisibility", "SetColumnOrder", "ResetTableFilter", "SaveCustomFilter", "RenameCustomFilter", "DeleteCustomFilter", "ResetTableConfiguration", "FetchTableConfiguration", "TableConfigurationFetched", "SaveTableConfiguration", "TableConfigurationSaved", "FetchError"];
    }
}

export function TableMsg$1_$reflection(gen0) {
    return union_type("Widgets.Table.Types.TableMsg`1", [gen0], TableMsg$1, () => [[["Item", array_type(ColumnDefinition$1_$reflection(gen0))]], [["Item", string_type]], [["Item", obj_type]], [["Item", bool_type]], [], [["Item", array_type(anonRecord_type(["id", string_type], ["value", obj_type]))]], [["Item", array_type(anonRecord_type(["id", string_type], ["value", obj_type]))]], [["Item", array_type(anonRecord_type(["desc", bool_type], ["id", string_type]))]], [["Item", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, bool_type])]], [["Item", array_type(string_type)]], [], [["Item", SavedTableFilter_$reflection()]], [["oldName", string_type], ["newName", string_type]], [["name", string_type]], [], [], [["Item", option_type(TableConfiguration_$reflection())]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

